module.exports = __webpack_public_path__ + "src/assets/img/page9/7943d7351d0e259086564523529eb292.png";